import { z } from 'zod';
import { fromCents, toCents } from './money.js';
/** A line of an invoice divided on more items of the plan Base (3.19). */
export const lineSplitSchema = z.object({
    /** Empty: the division is taken away. */
    parts: z
        .array(z.object({
        code: z.string().trim().min(1).max(12),
        amount: z.string().regex(/^-?\d{1,12}\.\d{2}$/, { message: 'Importo non valido' }),
    }))
        .max(20),
});
/** Why the parts cannot divide a line of this amount, or null. */
export function lineSplitError(lineAmount, parts) {
    if (parts.length < 2)
        return 'Servono almeno due voci';
    if (new Set(parts.map((part) => part.code)).size !== parts.length) {
        return 'Ogni voce una volta sola';
    }
    if (parts.some((part) => toCents(part.amount) === 0))
        return 'Ogni voce ha un importo';
    const line = toCents(lineAmount);
    if (parts.some((part) => toCents(part.amount) * line < 0)) {
        return 'Gli importi vanno nello stesso verso della riga';
    }
    const sum = parts.reduce((total, part) => total + toCents(part.amount), 0);
    if (sum === line)
        return null;
    const left = line - sum;
    return `Il totale non torna con la riga: ${left > 0 ? 'mancano' : 'in più'} ${fromCents(Math.abs(left)).replace('.', ',')} €`;
}
/** The biggest part: the item of an invoice that has none (3.19). */
export function mainPart(parts) {
    return parts.reduce((best, part) => Math.abs(toCents(part.amount)) > Math.abs(toCents(best.amount)) ? part : best);
}
//# sourceMappingURL=line-split.js.map